import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { componentStyles } from "./monday-demo-tabs-component.scss";
import DefaultProps from "./defaultProps";
import MondayDemoTabsAsset from "./monday-demo-tab-asset/monday-demo-tabs-asset";
import MondayDemoTimeline from "./monday-demo-timeline/monday-demo-timeline";

const MondayDemoTabsComponent = (props) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
  const [videoDurations, setVideoDurations] = useState([]);
  const [buttonHighlighted, setButtonHighlighted] = useState(false);
  const { fullParagraph, tabs, buttonConfig } = props;

  const VISIBILITY_SENSOR_OFFSET = 100;
  const DEMO_FINISHED_SELECTED_TAB_INDEX = -1;

  const onTabClick = ({ index }) => {
    setSelectedTab(index);
    setButtonHighlighted(false);
  };

  const onVideoEnded = () => {
    if (selectedTab < tabs.length - 1) {
      setSelectedTab(selectedTab + 1);
    }
    // last tab
    if (selectedTab === tabs.length - 1) {
      setSelectedTab(DEMO_FINISHED_SELECTED_TAB_INDEX); // demo finished
      setButtonHighlighted(true);
    }
  };

  const setVideoDuration = (duration) => {
    console.log(duration);
    if (videoDurations[selectedTab] !== duration) {
      const newVideoDurations = [...videoDurations];
      newVideoDurations[selectedTab] = duration;
      setVideoDurations(newVideoDurations);
    }
  };

  const getCurrentAsset = () => {
    if (selectedTab === DEMO_FINISHED_SELECTED_TAB_INDEX) {
      return tabs?.[tabs.length - 1]?.asset;
    }
    return tabs?.[selectedTab]?.asset;
  };

  const onVisibilityChange = (isVisible) => {
    if (!wasComponentEverVisible && isVisible) {
      setWasComponentEverVisible(true);
    }
  };

  return (
    <VisibilitySensor
      offset={{ bottom: VISIBILITY_SENSOR_OFFSET, top: VISIBILITY_SENSOR_OFFSET }}
      partialVisibility={true}
      onChange={onVisibilityChange}
      active={!wasComponentEverVisible} // turn it off once the component becomes visible
      scrollCheck={!wasComponentEverVisible} // turn it off once the component becomes visible
    >
      <div className="monday-demo-tabs-component">
        <FullParagraph {...fullParagraph} />
        <div className="monday-demo-tabs-asset-and-timeline">
          <MondayDemoTabsAsset
            asset={getCurrentAsset()}
            onVideoEnded={onVideoEnded}
            setVideoDuration={setVideoDuration}
          />
          <MondayDemoTimeline
            tabs={tabs}
            selectedTab={selectedTab}
            buttonConfig={buttonConfig}
            buttonHighlighted={buttonHighlighted}
            wasComponentEverVisible={wasComponentEverVisible}
            onTabClick={onTabClick}
            videoDuration={videoDurations[selectedTab]}
          />
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    </VisibilitySensor>
  );
};

MondayDemoTabsComponent.defaultProps = DefaultProps;

export default MondayDemoTabsComponent;
